//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
// import './style.scss'
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const yourLifestyle = useStore((state) => state.yourLifestyle);
  const setYourLifestyle = useStore((state) => state.setYourLifestyle);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.yourLifestyle.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={yourLifestyle}
          onChange={(value) => {
            setYourLifestyle(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'your-lifestyle',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'I spend my days sitting'}>
            <span>💻</span> {t('onboarding.yourLifestyle.options.sitting')}
          </Option>
          <Option value={'I try to move when i can'}>
            <span>🏌️‍♂</span> {t('onboarding.yourLifestyle.options.move')}
          </Option>
          <Option value={'Im on my feet all day long'}>
            <span>👟</span> {t('onboarding.yourLifestyle.options.feet')}
          </Option>
          <Option value={'I spend most of my day at home'}>
            <span>🏘</span> {t('onboarding.yourLifestyle.options.home')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
